import React from "react";
import clsx from "clsx";

import styles from "./emptyBlock.module.scss";

export const EmptyBlock = ({
	description = "No Records to Display",
	className = "",
	style = {},
}) => {
	return (
		<div className={clsx(styles.emptyBlock, className)} style={style}>
			<div className={styles.emptyBlockInner}>{description}</div>
		</div>
	);
};
